const tableConfig = [
  { id: 1, name: 'NUMBER', isSortable: false, info: '', field: 'number' },
  { id: 2, name: 'HEADING', isSortable: false, info: '', field: 'title' },
  { id: 3, name: 'DATE', isSortable: true, info: '', field: 'date' },
  { id: 4, name: 'URL', isSortable: false, info: '', field: 'url' },
  {
    id: 5,
    name: 'ATTENDANCE',
    isSortable: true,
    info: 'AUDIENCE',
    field: 'attendance'
  },
  {
    id: 6,
    name: 'VIEWS_COUNT',
    isSortable: true,
    info: 'VIEWING',
    field: 'averageAttendance'
  },
  {
    id: 7,
    name: 'RATIO',
    isSortable: false,
    info: 'TEXT',
    field: 'ratio'
  }
];

export default tableConfig;
